'use client';

import { c as _c } from "react/compiler-runtime";
import { TopNavProvider } from '@src/components/TopNavV3/TopNavContext';
import { defaultTopNavProps } from './TopNav.defaults';
import { TopNavDesktop } from './TopNavDesktop/TopNavDesktop';
import { TopNavMobile } from './TopNavMobile/TopNavMobile';
import { type TopNavProps } from './TopNavProps';
export const TopNavV3 = t0 => {
  const $ = _c(4);
  const props = t0 === undefined ? defaultTopNavProps : t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <TopNavMobile />;
    t2 = <TopNavDesktop />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== props) {
    t3 = <TopNavProvider topNavProps={props}>{t1}{t2}</TopNavProvider>;
    $[2] = props;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};